import React from "react";
import { Shield } from "lucide-react";

const PrivacyHero = () => {
  return (
    <section className="relative py-32 bg-gradient-to-br from-misty-sage to-sand-beige overflow-hidden">
      {/* Background Pattern */}
      <div className="absolute inset-0 lotus-pattern opacity-20"></div>

      {/* Sanskrit Text */}
      <div className="absolute top-20 right-10 text-6xl text-soft-saffron/30 font-sanskrit hidden md:block">
        धर्मः
      </div>

      <div className="container mx-auto px-6 relative z-10">
        <div className="max-w-4xl mx-auto text-center">
          {/* Breadcrumb */}
          <div className="mb-8">
            <span className="text-copper-brown text-sm">
              <a href="/" className="hover:text-forest-green transition-colors">
                Home
              </a>
              <span className="mx-2">•</span>
              <span className="text-forest-green">Privacy Policy</span>
            </span>
          </div>

          {/* Icon */}
          <div className="flex justify-center mb-6">
            <div className="bg-forest-green/10 p-4 rounded-full">
              <Shield className="w-12 h-12 text-forest-green" />
            </div>
          </div>

          {/* Main Heading */}
          <h1 className="font-heading text-5xl md:text-7xl font-bold text-forest-green mb-6 animate-gentle-fade">
            Privacy Policy
          </h1>

          {/* Subheading */}
          <p className="text-xl text-forest-green leading-relaxed max-w-3xl mx-auto animate-gentle-fade">
            At Cittasya®, your privacy is important to us. We are committed to
            protecting your personal data and respecting your trust.
          </p>

          {/* Decorative Element */}
          <div className="w-32 h-1 bg-gradient-to-r from-soft-saffron to-copper-brown rounded-full mx-auto mt-12"></div>
        </div>
      </div>
    </section>
  );
};

export default PrivacyHero;
